import { ImisResponseResult, QueryDefinitionItem } from "../models/imis.models";
import { PopupUtility } from "./popup.utility";
import { RestUtility } from "./rest.utility";

export class QueriesUtility {

    public static async getQueryDefinitionByPath(queryPath: string) {
        let queryDefinition: QueryDefinitionItem = null;

        let queryDefinitionResponse = await RestUtility.restApiSendData<ImisResponseResult<QueryDefinitionItem>>("/api/querydefinition/_execute", {
            "$type": "Asi.Soa.Core.DataContracts.GenericExecuteRequest, Asi.Contracts",
            "OperationName": "FindByPath",
            "Parameters": [queryPath]
        });
        if (queryDefinitionResponse?.Result) {
            queryDefinition = queryDefinitionResponse.Result;
        }

        // ensuring query definition is returned if this is indeed a non-cloud instance response
        if (queryDefinition == null && queryDefinitionResponse?.Result === undefined) {
            queryDefinition = <any>queryDefinitionResponse;
        }

        return queryDefinition;
    }

    public static async openQueryEditorByPath(queryPath: string) {
        // check if query has rest access
        let queryRestAccess = await QueriesUtility.getQueryRestAccessByPath(queryPath);
        if (queryRestAccess == null) {
            throw new Error("Query access request failed for path: " + queryPath);
        }
        if (!queryRestAccess) {
            // set rest access
            let isSuccess = await QueriesUtility.setQueryRestAccessByPath(queryPath, true);
            if (!isSuccess) {
                throw new Error("Query rest access update failed for path: " + queryPath);
            }
        }

        let queryDefinition = await QueriesUtility.getQueryDefinitionByPath(queryPath);
        if (queryDefinition != null) {
            let windowName = `QueryEditor_${queryDefinition.QueryDefinitionId}`;
            PopupUtility.createPopup({
                title: queryPath,
                url: `/iMIS/QueryBuilder/Design.aspx?iMode=Edit&TemplateType=E&iUniformKey=${queryDefinition.QueryDefinitionId}&iOperation=Edit`,
                width: "90%",
                height: "90%",
                windowName: windowName,
                callback: (sender, args) => {
                    let popupWindow = window.GetRadWindowManager().getWindowByName(windowName);
                    if (popupWindow) {
                        window.GetRadWindowManager()["removeWindow"](popupWindow);
                    }
                }
            });
        } else {
            let errorMessage = "Query not found for path: " + queryPath;

            console.error(errorMessage);
            throw errorMessage;
        }

        // ensure query access is reset
        if (!queryRestAccess) {
            let isSuccess = await QueriesUtility.setQueryRestAccessByPath(queryPath, false);
            if (!isSuccess) {
                console.error("Query rest access reset failed for path: " + queryPath);
            }
        }
    }

    public static async getQueryRestAccessByPath(queryPath: string) {
        let queryRestAccess: boolean = null;

        let queryDefinitionResponse = await RestUtility.restApiSendData<ImisResponseResult<any>>("/api/querydefinition/_execute", {
            "$type": "Asi.Soa.Core.DataContracts.GenericExecuteRequest, Asi.Contracts",
            "OperationName": "GetRestAccess",
            "Parameters": {
                "$type": "System.Collections.ObjectModel.Collection`1[[System.Object, mscorlib]], mscorlib",
                "$values": [
                    {
                        "$type": "System.String[]",
                        "$values": [queryPath]
                    }
                ]
            }
        }, "POST", true);
        if (queryDefinitionResponse?.Result != null) {
            let resultValue = queryDefinitionResponse.Result.$values[0];
            let regex = /'(.+?)' REST access set to '(.*?)'/g;
            let match = regex.exec(resultValue);
            if (match && match.length >= 3) {
                queryRestAccess = match[2].toLowerCase() === "true";
            }
        }

        return queryRestAccess;
    }

    public static async getQueryRestAccessByPaths(queryPaths: string[]) {
        let queryRestAccess: { [key: string]: boolean } = null;

        let queryDefinitionResponse = await RestUtility.restApiSendData<ImisResponseResult<any>>("/api/querydefinition/_execute", {
            "$type": "Asi.Soa.Core.DataContracts.GenericExecuteRequest, Asi.Contracts",
            "OperationName": "GetRestAccess",
            "Parameters": {
                "$type": "System.Collections.ObjectModel.Collection`1[[System.Object, mscorlib]], mscorlib",
                "$values": [
                    {
                        "$type": "System.String[]",
                        "$values": queryPaths
                    }
                ]
            }
        }, "POST", true);
        if (queryDefinitionResponse?.Result != null) {
            queryRestAccess = {};
            queryDefinitionResponse.Result.$values.forEach(resultValue => {
                let regex = /'(.+?)' REST access set to '(.*?)'/g;
                let match = regex.exec(resultValue);
                if (match && match.length >= 3) {
                    queryRestAccess[match[1]] = match[2].toLowerCase() === "true";
                } 
            });
        }

        return queryRestAccess;
    }

    public static async setQueryRestAccessByPath(queryPath: string, restAccess: boolean) {
        let isSuccess = false;

        let queryDefinitionResponse = await RestUtility.restApiSendData<ImisResponseResult<any>>("/api/querydefinition/_execute", {
            "$type": "Asi.Soa.Core.DataContracts.GenericExecuteRequest, Asi.Contracts",
            "OperationName": "SetRestAccess",
            "Parameters": {
                "$type": "System.Collections.ObjectModel.Collection`1[[System.Object, mscorlib]], mscorlib",
                "$values": [
                    {
                        "$type": "System.String[]",
                        "$values": [queryPath]
                    },
                    {
                        "$type": "System.Boolean",
                        "$value": restAccess
                    }
                ]
            }
        }, "POST", true);
        if (queryDefinitionResponse?.Result != null) {
            let resultValue = queryDefinitionResponse.Result.$values[0];
            let regex = /'(.+?)' REST access set to '(.*?)'/g;
            let match = regex.exec(resultValue);
            if (match && match.length >= 3) {
                isSuccess = true;
            }
        }

        return isSuccess;
    }
}
